import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ACTORS_QUERY_KEYS } from "Actors/Api/Queries/queryKeys";
import {
  apiPut,
  getApiUrl,
  type PutUsersUserIDProfilePictureFetchResponse,
  putUsersUserIDProfilePicturePath,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";

interface UploadActorProfilePictureParams {
  userID: string;
  file: File;
}

export function useUploadActorProfilePictureMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ userID, file }: UploadActorProfilePictureParams) => {
      const formData = new FormData();
      formData.append("file", file);
      return apiPut(
        `${getApiUrl()}${putUsersUserIDProfilePicturePath(userID)}`,
        formData,
        undefined,
      ) as Promise<PutUsersUserIDProfilePictureFetchResponse>;
    },
    {
      translationPrefix: getResourcePath(
        Resources.ApiErrors.UploadUserProfilePicture,
      ),
    },
  );

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ACTORS_QUERY_KEYS.all,
        exact: false,
      });
    },
  });
}
